import script from "./OrderTicketsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTicketsForm.vue?vue&type=script&setup=true&lang=js"

import "./OrderTicketsForm.vue?vue&type=style&index=0&id=2d5acfb9&lang=scss"

const __exports__ = script;

export default __exports__